import React from 'react' 
import Slider from "react-slick";
const HomeSlider = () => {
  var settings = {
    autoplay: true,
    infinite: true,
    autoplaySpeed: 2000,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: true,
    adaptiveHeight: true, 
  };
  return (
    <>
      <div className="slider-sec">
      <Slider {...settings}>
             <div className="item">
               <img src="https://webapi.entab.info/api/image/MMSKN/public/Images/sld0.png"  className="img-fluid"  alt="Mercy Memorial School, Kanpur"/>
             </div>
             <div className="item">
               <img src="https://webapi.entab.info/api/image/MMSKN/public/Images/sld-2.jpg"  className="img-fluid"  alt="Mercy Memorial School, Kanpur"/>
             </div>
             <div className="item">
               <img src="https://webapi.entab.info/api/image/MMSKN/public/Images/sld-3.jpg"  className="img-fluid"  alt="Mercy Memorial School, Kanpur"/>
             </div>
             <div className="item">
               <img src="https://webapi.entab.info/api/image/MMSKN/public/Images/sld-4.jpg"  className="img-fluid"  alt="Mercy Memorial School, Kanpur"/>
             </div>
             <div className="item">
               <img src="https://webapi.entab.info/api/image/MMSKN/public/Images/sld-5.jpg"  className="img-fluid"  alt="Mercy Memorial School, Kanpur"/>
             </div>
             <div className="item">
               <img src="https://webapi.entab.info/api/image/MMSKN/public/Images/sld-6.jpg"  className="img-fluid"  alt="Mercy Memorial School, Kanpur"/>
             </div>
             <div className="item">
               <img src="https://webapi.entab.info/api/image/MMSKN/public/Images/sld-7.jpg"  className="img-fluid"  alt="Mercy Memorial School, Kanpur"/>
             </div>
      </Slider>
        <div className="overBox">
          <h2>Our vision</h2>
          <p> Our institution has been shaped and guided by a remarkable group of visionaries whose leadership, dedication and unwavering commitment to education have laid the foundation for its success.</p>
          
        </div>
      </div>
    </>
  )
}

export default HomeSlider
